import React from 'react';
import {  NumberFormatBase } from 'react-number-format';
import { useField,  useFormikContext} from "formik";
import { Form } from "react-bootstrap";

 export const format = (val) => {
    if (val === '') return '';
    let month = val.substring(0, 2);
    const year = val.substring(2, 4);

    if (month.length === 1 && month[0] > 1) {
      month = `0${month[0]}`;
    } else if (month.length === 2) {
      // set the lower and upper boundary
      if (Number(month) === 0) {
        month = `01`;
      } else if (Number(month) > 12) {
        month = '12';
      }
    }
    return `${month}/${year}`
  };

export default function CardExpiryField(props) {
  const {name, label, controlId, ...rest} = props
  const [field,meta ] = useField(name);
  // const { setValue } = helpers;
  const { setFieldValue } = useFormikContext();
 

  return (
     <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <NumberFormatBase  
              name={name} 
              value={field.value}
              customInput={Form.Control}
              onValueChange={(values, sourceInfo) => {
                setFieldValue(name, values.value);
              }}
              format={format} 
              className={meta.error && meta.touched && "border border-danger"}
              {...rest} 
            />
             {meta.error && meta.touched ? (
                <small className='text-danger'>{meta.error}</small>
            ) : null}
        </Form.Group>
  )

}